var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"8rOL_XACutBXDw-JPAV8m"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://178a87a7a07a59d7fa91c543dcd22520@o4509633140097024.ingest.us.sentry.io/4509673208479744',
  tracesSampleRate: 1.0,

  // Enable capturing full stack traces
  attachStacktrace: true,

  // Send environment and release info
  environment: process.env.NODE_ENV,

  // Debug output to console
  debug: true,

  enabled: process.env.NODE_ENV === 'production',
});
